module.exports = __webpack_public_path__ + "media/images/right_highlighted_arrow-77361aab277cf0f1b1f28d6f77d98808.png";